import { h } from 'preact';
import styles from './SkeletonCard.module.scss';
export function SkeletonCard() {
    return (h("div", { class: styles.skeletonCard, "aria-hidden": "true" },
        h("div", { class: styles.skeletonImage }),
        h("div", { class: styles.skeletonInfo },
            h("div", { class: styles.skeletonTitleLine1 }),
            h("div", { class: styles.skeletonPrice }),
            h("div", { class: styles.skeletonSwatches },
                h("div", { class: styles.skeletonSwatch }),
                h("div", { class: styles.skeletonSwatch }),
                h("div", { class: styles.skeletonSwatch })))));
}
